export function addOneDayInDate(dateStr) {
  const date = new Date(dateStr);
  date.setDate(date.getDate()); // server
  // date.setDate(date.getDate()+1); // local
  // console.log('date.setDate(date.getDate() + 1)',date.setDate(date.getDate() + 1)); // fix me:
  return date.toISOString().slice(0, 10);
}
